export const treatmentEn = {
  "Soins": "Care",
  "Prothese": "Prosthesis",
  "Soins gencive": "Gum Care",
  "Soins pediatre": "Pediatric care",
  "Soins de bouche": "Oral care",
  "Conservateur": "Conservative care",
  "Type": "Type",


  // Server Side 
  "Le traitement deja existe": "The treatment already exists",
  "Le nom du traitement est obligatoire": "The name of the treatment is mandatory",
  "Le type du traitement est obligatoire": "The type of processing is mandatory",
  "Le prix du traitement est obligatoire": "The price of the treatment is obligatory",

  "Traitement deja assuré": " Treatment is already assured",


}